var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("router-link", {
    staticClass: "logo-wrapper",
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "logo",
    staticStyle: {
      width: "auto",
      height: "20px",
      "background-color": "transparent",
      "border-radius": "0",
      "vertical-align": "middle"
    },
    attrs: {
      src: require("../../../assets/logo.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "logo-title verticalMiddle"
  }, [_vm._v("后台管理系统")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };